<template>
  <!-- <top-navigation></top-navigation> -->

  <!--  <nav>-->
  <!--    <router-link to="/">Home</router-link> |-->
  <!--    <router-link to="/about">About</router-link>-->
  <!--  </nav>-->
  <router-view />

  <!-- <bottom-footer></bottom-footer> -->
</template>

<script lang="ts">
import { defineComponent } from "vue";
// import TopNavigation from "@/components/navigation/navigation.vue";
// import BottomFooter from "@/components/footer/bottom-footer.vue";
export default defineComponent({
  name: "App",
  components: {},
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
